'use strict';

var SnapshotSummaryDirective = function SnapshotSummaryDirective() {
  return {
    restrict: 'E',
    template: require('../templates/snapshot-summary.html'),
    scope: {},
    replace: true,
    controller: 'SnapshotSummaryController',
    link: function link(scope) {
      scope.$on('Chart:SnapshotDates:selectedSnapshotDate', scope.onSelectSnapshotDate);
    }
  };
};
SnapshotSummaryDirective.$inject = [];
module.exports = SnapshotSummaryDirective;